export default __webpack_public_path__ + "static/media/Heaven's Ji Pang-Ee.0ef6577e.jpg";